import React, { useRef, useContext } from "react";
import "./login.css";
import { Email, Lock } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Context } from "../../context/Context";
import Swal from "sweetalert2";

const Login = () => {
  const username = useRef();
  const password = useRef();
  const { dispatch } = useContext(Context);
  const history = useHistory();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch({ type: "LOGIN_START" });
      const res = await axios.post(
        "https://www.rezerwacjaparkingu.com/backend_artlot/api/users/login",
        {
          login: username.current.value,
          password: password.current.value,
        }
      );
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: { ...res.data, token: "SECRET_@#$@$$@@$WEFWFQW" },
      });
      dispatch({
        type: "LOGIN_SUCCESS_TOKEN",
        payload: res.data.token,
      });
      window.sessionStorage.setItem(
        "user",
        JSON.stringify({
          ...res.data,
          token: "SECRET_@#$@$$@@$WEFWFQW",
          refreshToken: res.data.token,
        })
      );
      window.sessionStorage.setItem("refreshToken", res.data.token);
      Swal.fire({
        icon: "success",
        title: "Sukces",
        text: "Zalogowano pomyślnie",
        confirmButtonText: "Dalej",
        confirmButtonColor: "#1267a2",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/admin");
        }
      });
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Nieprawidłowe dane!",
        confirmButtonText: "Cofnij",
        confirmButtonColor: "#1267a2",
      });
    }
  };
  return (
    <div className="login">
      <div className="loginWrapper">
        <div className="loginLeftImage"></div>
        <div className="loginLeft">
          <h3 className="loginLogo">Log In</h3>
        </div>
        <div className="loginRight">
          <form className="loginBox" onSubmit={handleSubmit}>
            <div className="IconwithInput">
              <Email className="svgImage" />
              <input
                placeholder="login..."
                className="loginInput"
                type="text"
                minLength="3"
                required
                ref={username}
              />
            </div>
            <div className="IconwithInput">
              <Lock className="svgImage" />
              <input
                placeholder="password..."
                className="loginInput"
                type="password"
                required
                minLength="3"
                ref={password}
              />
            </div>
            <div className="loginBoxBottom">
              <button type="submit" className="loginButton">
                Log In
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
